import { createAuth0 } from '@auth0/auth0-vue'

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()

  const auth0 = createAuth0({
    domain: 'https://login.bcc.no',
    clientId: runtimeConfig.public.auth.clientId,
    cacheLocation: 'localstorage',
    authorizationParams: {
      redirect_uri: runtimeConfig.public.auth.redirectUri,
    },
  })

  nuxtApp.vueApp.use(auth0)

  // Provided rather than reached through useAuth0(), which is inject()-based:
  // an async composable loses the component instance across its own `await`,
  // and inject() then returns undefined. useNuxtApp() has no such problem.
  return {
    provide: { auth0 },
  }
})
